import PropTypes from "prop-types";
import React from "react";
import HRVLineChart from "./HRVLineChart";

function HRVChart({ hrvData }) {
  return <HRVLineChart hrvData={hrvData} />;
}

HRVChart.propTypes = {
  hrvData: PropTypes.shape({
    range: PropTypes.string,
    data_points: PropTypes.arrayOf(
      PropTypes.shape({
        timestamp: PropTypes.string,
        hrv: PropTypes.number,
        bpm: PropTypes.number,
      })
    ),
  }),
};

HRVChart.defaultProps = {
  hrvData: {
    range: "day",
    data_points: [],
  },
};

export default HRVChart;
